export default __webpack_public_path__ + "static/media/437.f35e46d2.jpg";